import { createContext, useContext } from "react";
import { TeamsIncomingCall } from "@azure/communication-calling";
import {
	OngoingCall,
	OutboundCallRequest,
} from "@/repository/models/outboundCall";

interface AcsContextValue {
	incomingCall: TeamsIncomingCall | null;
	ongoingCalls: Map<string, OngoingCall> | null;
	callerInfo: string;
	startCall: (data: OutboundCallRequest) => Promise<void>;
	answerCall: () => Promise<void>;
	rejectCall: () => Promise<void>;
	hangUpCall: (callId: string) => Promise<void>;
	muteCall: (callId: string) => Promise<void>;
	muteAllRemoteParticipants: (callId: string) => Promise<void>;
	unmuteCall: (callId: string) => Promise<void>;
	holdCall: (callId: string) => Promise<void>;
	unholdCall: (callId: string) => Promise<void>;
}

export const AcsContext = createContext<AcsContextValue>({
	incomingCall: null,
	ongoingCalls: null,
	callerInfo: "",
	startCall: async () => {},
	answerCall: async () => {},
	rejectCall: async () => {},
	hangUpCall: async () => {},
	muteCall: async () => {},
	muteAllRemoteParticipants: async () => {},
	unmuteCall: async () => {},
	holdCall: async () => {},
	unholdCall: async () => {},
});

export const useAcs = () => useContext(AcsContext);

// Whether this client has a live ACS call. Kept apart from AcsContext so its readers re-render only
// when it flips, not on every AcsContext value change.
export const AcsOngoingCallContext = createContext<boolean>(false);

export const useHasOngoingAcsCall = () => useContext(AcsOngoingCallContext);
